import { useState } from 'react';
import classnames from 'classnames/bind';
import Cookies from 'js-cookie';

import { RECOMMEND_PROCESS_LIST } from '@portalCommon/constants';
import { TitleText } from '@portalCommon/recommend';
import type { CluesReferrerReturnType } from '@portalCommon/services/recommend';
import { OptimizedImg } from '@commonPackage/components';
import API from '@/services';
import { EditionBlock, RecommendBtn, RecommendCheckPhone, RecommendTableModal } from '..';

import styles from './index.module.less';

const cx = classnames.bind(styles);

const ProcessSteps = () => (
  <div className={cx(`process-steps`)}>
    {[1, 2, 3, 4, 5, 6, 7].map(item => (
      <span key={item} className={cx(item % 2 ? 'round' : 'rectangle')}></span>
    ))}
  </div>
);

const ProcessList = () => {
  const renderRound = (i: number) => (
    <div className={cx(`item-bound`)}>
      <div>
        <span>0{i}</span>
      </div>
    </div>
  );

  return (
    <div className={cx(`process-list`)}>
      {RECOMMEND_PROCESS_LIST.map((item, index) => (
        <div key={index} className={cx(`list-item`)}>
          {renderRound(index + 1)}
          <OptimizedImg loading="lazy" src={item.ico} alt={item.ico} />
          <p className={cx(`item-text`)}>{item.text}</p>
          <p className={cx(`item-tip`)} dangerouslySetInnerHTML={{ __html: item.tip }}></p>
        </div>
      ))}
    </div>
  );
};

export function ProcessBlock() {
  const [checkOpen, setCheckOpen] = useState(false);
  const [tableOpen, setTableOpen] = useState(false);
  const [tableList, setTableList] = useState<CluesReferrerReturnType['items']>([]);

  // open 控制列表,list 验证手机号接口返回回传到此
  const checkModalClose = (open: boolean, list?: CluesReferrerReturnType['items']) => {
    setCheckOpen(false);
    open && setTableOpen(true);
    list?.length && setTableList(list);
  };

  // 校验推荐人token;
  const verifyCookieExpired = async () => {
    const referrersToken = Cookies.get('referrers_token');

    if (!referrersToken) return setCheckOpen(true);

    try {
      const { data } = await API.recommend.cluesReferrer();
      setTableList(data.items);
      setTableOpen(true);
    } catch {
      setCheckOpen(true);
    }
  };

  return (
    <EditionBlock className={cx(`process-block`)}>
      <TitleText text="推荐流程" />
      <ProcessSteps />
      <ProcessList />
      <div className={cx(`operate`)}>
        <RecommendBtn />
      </div>
      <p className={cx(`operate-look`)} onClick={verifyCookieExpired}>
        查看我的推荐 &nbsp;&gt;
      </p>
      {checkOpen && <RecommendCheckPhone onClose={checkModalClose} />}
      {tableOpen && <RecommendTableModal onClose={setTableOpen.bind(null, false)} list={tableList} />}
    </EditionBlock>
  );
}
